import { render, staticRenderFns } from "./CUModal.vue?vue&type=template&id=78982ca6"
import script from "./CUModal.vue?vue&type=script&lang=ts"
export * from "./CUModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports